"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHANNEL_TYPE = exports.CATEGORY = exports.STORAGE_KEY_SUFFIX = exports.PINPOINT_KEY_PREFIX = void 0;
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
exports.PINPOINT_KEY_PREFIX = 'Pinpoint';
exports.STORAGE_KEY_SUFFIX = '_inAppMessages';
exports.CATEGORY = 'InAppMessaging';
exports.CHANNEL_TYPE = 'IN_APP';
